import { object } from "../helpers/object";
import { debug } from "../helpers/debug";
import { responsive } from "../helpers/responsive";
import { utils } from "../helpers/utils";

/*------------------------------------*\
  #FOOTER

  Class gestion des interaction du footer
  - ouverture/fermerture des liens en mobile

  [data-js-module="footer"]
  [data-js-trigger="footer--button"] // trigger js pour l'affichage en mobile des liens du footer
  [data-js-footer-content-expanded="{bool}"] // état de visibilité du conteneur de liens du footer
\*------------------------------------*/
class Footer {
  DOM_triggers_footerButtons;
  DOM_footerContent;

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
    // DOM ELEMENTS
    this.DOM_triggers_footerButtons = object.toArray(document.querySelectorAll('[data-js-trigger="footer--button"]'));
    this.DOM_footerContent = object.toArray(document.querySelectorAll('[data-js-footer-content-expanded]'));

    

  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    // DEFAULT EVENT
    document.addEventListener('click', this.clickHandler);
    // RESPONSIVE
    this.responsiveHandler();

    if(debug.DEBUG) console.log('modules/footer.js');
  }
  /**
   * CLICK HANDLER
   * 
   * Gestionnaire des event de la barre de navigation
   * @param {event} event 
   * @returns 
   */
  clickHandler = (event) => {
    if (event.target.matches('[data-js-trigger-prevent]')) return;
    
    if (event.target.matches('[data-js-trigger="footer--button"]')) {
      // TOGGLER AFFICHAGE NAVIGATION MOBILE
      if (!responsive.is('lg')) {
        const expanded = !utils.dataBool(event.target.getAttribute('aria-expanded'));
        const target = document.getElementById(event.target.getAttribute('aria-controls'));
        event.target.setAttribute('aria-expanded', expanded);
        target.setAttribute('data-js-footer-content-expanded', expanded);
      }
    }
  }
  /**
   * FOOTER BUTTONS REFRESH
   * 
   * gestion des états des boutons et des liste 
   * en desktop|mobile
   */
  footerButtonsRefresh = () => {
    this.DOM_triggers_footerButtons.forEach((element) => {
      element.setAttribute('aria-expanded', responsive.is('lg'));
    });
    this.DOM_footerContent.forEach((element) => {
      element.setAttribute("data-js-footer-content-expanded", responsive.is('lg'))
    })
  }
  /**
   * RESPONSIVE
   * 
   * Gestion de la maj du component
   * en fonction du media query
   */
  responsiveHandler = () => {
    document.addEventListener('RESPONSIVE_HAS_CHANGED', (event) => {
      this.footerButtonsRefresh();
    });
    this.footerButtonsRefresh();
  }
}
export const footer = new Footer('[data-js-module="footer"]'); 